import { WarehouseTable } from 'modules/warehouse';

const ObjectCardProducts = ({vobjectFull}) => {

    return (
        <div className="px-3">
            <WarehouseTable
                onlyView={true}
                setShowTransfer={null}
                stocksList={vobjectFull?.stocks}/>
        </div>
    )
}

export default ObjectCardProducts;